export enum OnboardingSplit {
    SPLIT1 = 'split1',
    SPLIT2 = 'split2',
}